var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/\uEA15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Entry---Trailer-details",
    transform: "translate(-883.000000, -238.000000)",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(128.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-card",
    transform: "translate(24.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quick-profile",
    transform: "translate(24.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724.712,31.632 L722.888,33.456 L719.144,29.712 L720.968,27.888 C721.160001,27.695999 721.395999,27.6 721.676,27.6 C721.956001,27.6 722.191999,27.695999 722.384,27.888 L724.712,30.216 C724.904001,30.408001 725,30.6439986 725,30.924 C725,31.2040014 724.904001,31.439999 724.712,31.632 Z M707,41.856 L718.064,30.792 L721.808,34.536 L710.744,45.6 L707,45.6 L707,41.856 Z",
    id: "\\uEA15"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.3af5fe6df4552553a6971df590de9b0a.svg";
export { ForwardRef as ReactComponent };